import { render, staticRenderFns } from "./setMungBean.vue?vue&type=template&id=025924fe&scope=scope"
import script from "./setMungBean.vue?vue&type=script&lang=js"
export * from "./setMungBean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports